import React from 'react';
import CustomContent from '../../components/Content/CustomContent';

const ExploreMaltaPolicy = () => {
  return (
    <CustomContent>
      <p style={{ margin: '0px', padding: '0px;' }}>&nbsp;</p>
      <h3
        style={{
          margin: '28px 0px 0px',
          padding: '0px',
          fontSize: '1.142em',
          fontStyle: 'inherit',
          lineHeight: '1.5',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'normal',
          letterSpacing: '-0.008em',
        }}
      >
        MuseumSense - Mobile App Master Privacy Policy
      </h3>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>INTRODUCTION</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        This Master Privacy Policy (“Privacy Policy”) relates to the MuseumSense
        App branded as eXplore Malta (hereinafter referred to as the “App”), the
        services provided by MINISTRY FOR THE NATIONAL HERITAGE, THE ARTS AND
        LOCAL GOVERNMENT Chateau de La Ville, Archbishop Street, Valletta the
        owner of the App, (&quot;We&quot;, &quot;Us&quot;, &quot;Our&quot;,
        &quot;Ourselves&quot; and/or &quot;eXplore Malta&quot;) and any related
        software applications (&quot;Apps‟&quot;, where Personal Data is
        processed by the same (via the App, any of Our Apps or otherwise)
        relating to You. In this Master Privacy Policy, &quot;You&quot; and
        &quot;Your&quot; and &quot;User&quot; refer to an identified or
        identifiable natural person being the User of the App and/or client (or
        prospective client) of any of Our services/products. Our full details,
        including contact details, can be read below.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;You may be reading this Privacy Policy as a User or visitor of the
        App or You may have been directed here by one (or more) of Our
        agreements, Our condensed privacy policies or Our other notices (digital
        or otherwise).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;Although this Privacy Policy provides detailed, layered
        information on how and why We generally process Personal Data (via the
        App, in shop, or otherwise) as well as detailed information about Your
        various rights, the specific and tailor-made content of such agreements,
        condensed policies or other notices will, in most cases, provide You
        with more focused and detailed information on specific processing
        operations (for example, the specific legal basis for processing certain
        categories of Personal Data and the specific purpose for doing so
        depending on the matter at hand).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;Although Our goal is to always be as clear and transparent as
        possible, We appreciate that legal documents can sometimes be difficult
        to read. However, We strongly encourage You to read this Privacy Policy
        (which is layered for Your convenience) with care. Please do not hold
        back from contacting Us for any clarification You may need. For example,
        if You need clarification on a specific legal basis We are relying on to
        process Your Personal Data for a specific processing operation, We would
        be happy to provide You with any such information You may need.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>APPLICABLE LAWS</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        As an entity established in Malta, EU, the main privacy laws that are
        applicable to Us in so far as You are concerned, are as follows:
      </p>

      <ul
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'disc',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            The Maltese Data Protection Act (Chapter 440 of the Laws of Malta)
            as well as the various subsidiary legislation issued under the same
            – the &quot;DPA&quot;;
          </p>
        </li>
        <li style={{ marginTop: '4px' }}>
          <p style={{ margin: '0px', padding: '0px;' }}>
            The Regulation (EU) 2016/679 of the European Parliament and of the
            Council of 27 April 2016 on the protection of natural persons with
            regard to the processing of Personal Data and on the free movement
            of such data, and repealing Directive 95/46/EC (General Data
            Protection Regulation) – the “GDPR”. All the above referred to
            together as the “Data Protection Laws”
          </p>
        </li>
      </ul>

      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>WHAT IS PERSONAL DATA?</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &ldquo;PERSONAL DATA&rdquo; means any information that identifies You as
        an individual or that relates to an identifiable individual.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Whenever it is not possible or feasible for Us to make use of anonymous
        and/or anonymised data (in a manner that does not identify any Users of
        the App or customers of Our services), We are nevertheless committed to
        protecting Your privacy and the security of Your Personal Data at all
        times. &nbsp;
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        We collect Personal Data in various ways both digitally via the App
        (either when You choose to provide Us with certain data or in some
        cases, automatically or from third parties) as well as non-digitally
        (for example when You fill in a physical form to benefit from one or
        more of Our services).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>PERSONAL DATA WE COLLECT ABOUT YOU</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        There are various categories of Personal Data that We collect about You,
        namely
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;TRACKING DATA:
      </p>
      <ul
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'disc',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>Location Data</p>
        </li>
      </ul>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        ADDITIONAL INFORMATION:
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        In some cases, (for example, if You are a client [or prospective client]
        of Our services, via the App, any App or otherwise) We may request
        additional Personal Data as a means of securely identifying You or for
        another similar lawful purpose (which will be explained in the table
        below and/or in a condensed policy/notice that may have directed You
        here). The additional information We may request from You to be able to
        provide You with Our services includes:
      </p>
      <ul
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'disc',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            More secure identification methods
          </p>
        </li>
        <li style={{ marginTop: '4px' }}>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Credentials/references
          </p>
        </li>
        <li style={{ marginTop: '4px' }}>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Certain special categories of data (sensitive Personal Data) such as
            payslips, bank account statements and utility bills (only where
            necessary and with the necessary safeguards in place).
          </p>
        </li>
      </ul>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Many of the categories of Personal Data above are collected directly
        from You (for example, Your Contact Details and Your Registration Data).
        However, WE MAY ALSO COLLECT PERSONAL DATA FROM OTHER SOURCES, including
        data companies, publicly accessible databases, joint marketing partners,
        social media platforms and other third parties. We may also receive
        Personal Data about You from third parties when We need to confirm Your
        Contact Details or even certain Financial Information. Should this be
        the case, and when acting as a data controller We will take all measures
        as required by law to further inform You about the source of such
        Personal Data as well as the categories of Personal Data We collect and
        process. There are certain instances at law where We are specifically
        forbidden from disclosing to You such activity (for example, when
        carrying out due diligence for anti-money laundering purposes).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;In case of uncertainty over who is the data controller, please
        contact us at the details below.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        For a detailed description of the reasons why We process (as a data
        controller) the categories of Personal Data above (and any other
        specific Personal Data We process) as well as the corresponding legal
        ground(s) for doing so please see the &quot;What We Use Your Personal
        Data For (Purpose of Processing)‟ below.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        For information/Personal Data that We may collect automatically via the
        App, please see the Cookies section below.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>SOCIAL MEDIA</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;If You choose to connect one or more of Your social media accounts
        with Our App (if this option is available) to enable the sharing of
        Personal Data via social media platforms, certain categories of Personal
        Data relating to You from Your social media account(s) will be shared
        with Us.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>HOW AND WHY WE COLLECT PERSONAL DATA</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        As a general rule, when acting as a data controller, We do not collect
        any Personal Data, that is, information that identifies You as an
        individual other than that which You choose to provide to Us such as the
        data (including Contact Details and Registration Data) You provide when
        registering with Our App (where this is available), when contacting Us
        with enquiries relating to Our goods and/or services when subscribing to
        any service offered by Us or via Our App, such as any newsletters as may
        be issued by Us from time to time or even when subscribing to any offers
        We (and/or Our affiliates and/or corporate partners) may offer from time
        to time (see Personal Data We Collect About You above).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Unless otherwise specified and subject to various controls, as a general
        rule, We only collect Personal Data (from You or elsewhere) that We:
      </p>
      <ul
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'disc',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Need to be able to provide You with the goods and/or services You
            request from Us
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Are legally required to collect/use and to keep for a predetermined
            period of time
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Believe to be necessary for Our legitimate business interests
          </p>
        </li>
      </ul>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        For a detailed description of the reasons why we process specific
        categories of personal data as well as the corresponding legal ground(s)
        for doing so, please see the &quot;What We Use Your Personal Data For
        (Purpose of Processing)‟ below.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>PERSONAL DATA RELATING TO THIRD PARTIES</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        By providing Us with or allowing Us to access Personal Data relating to
        individuals other than
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Yourself, You are letting Us know that You have the authority to send Us
        that Personal Data or the authority to permit Us to access those data in
        the manner described in this Privacy Policy.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>
          WHAT WE USE YOUR PERSONAL DATA FOR (PURPOSE OF PROCESSING)
        </strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;The following is a description (in a clear and plain manner) of
        what We use Your Personal Data for and the corresponding legal ground(s)
        we rely on for doing so.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;For more detail on what is meant by terms such as &quot;Contact
        Details‟, &quot;Registration Data‟ and other categories of Personal Data
        used in the tables below, please see the section above relating to
        Personal Data We Collect About You.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;Please note that WHERE WE RELY ON YOUR CONSENT, THIS CAN BE
        WITHDRAWN AT WILL (See Special Note on Consent below).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>
          PROSPECTIVE CLIENTS/USERS OF THE App/NEW CLIENTS OF OUR SERVICES:
          PURPOSE OF THE PROCESSING CATEGORIES OF PERSONAL DATA LEGAL BASIS FOR
          PROCESSING
        </strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Purpose of the Processing
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;Location Data: Location Data is being collected for 3 sole
        reasons:
      </p>
      <ol
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'decimal',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            To provide more context when Maps are loaded within the App and
            hence provide clear reference of where the Points of Interest are in
            relation to the actual user location.
          </p>
        </li>
        <li style={{ marginTop: '4px' }}>
          <p style={{ margin: '0px', padding: '0px;' }}>
            To enable Bluetooth beacon detection - the libraries being used for
            such functionality require that the Bluetooth is ON and that the
            Location is ON when using the app. When these settings are ON the
            user is provided with the experience of being presented just in time
            content that represents Point of Interest information.
          </p>
        </li>
        <li style={{ marginTop: '4px' }}>
          <p style={{ margin: '0px', padding: '0px;' }}>
            To provide statistical information from where the App Content is
            loaded.
          </p>
        </li>
      </ol>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Should We need to process Your data for a new purpose in the future,
        which is entirely unrelated to the above, We will inform You of such
        processing in advance and You may exercise Your applicable rights (as
        explained below) in relation to such processing.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Finally, do note that without certain Personal Data relating to You, We
        may not be in the position to provide some or all of the services You
        expect from Us or even to guarantee the full functionality of Our App.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>SPECIAL NOTE ON CONSENT</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        For the avoidance of all doubt, We would like to point out that in those
        limited cases where We cannot or choose not to rely on another legal
        ground (for example, Our legitimate interests), We will process Your
        Personal Data on the basis of Your consent. In some cases, We will
        require Your explicit consent, for example, when, on the basis of Your
        explicit consent We will process special categories of data concerning
        You such as bank account statements, utility bills and payslips (what
        was previously referred to as &quot;sensitive Personal Data‟) that might
        be needed as part of Our processing of Your application for Monthly or
        yearly Payments. &nbsp;
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;In those cases where We, as a data controller process on the basis
        of Your consent (which We will never presume but which We shall have
        obtained in a clear and manifest manner from You), YOU HAVE THE RIGHT TO
        WITHDRAW YOUR CONSENT AT ANY TIME and this, in the same manner as You
        shall have provided it to Us.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;Should You exercise Your right to withdraw Your consent at any
        time (by writing to Us at the physical or email address below), We will
        determine whether at that stage an alternative legal basis exists for
        processing Your Personal Data (for example, on the basis of a legal
        obligation to which We are subject) where We would be legally authorised
        (or even obliged) to process Your Personal Data without needing Your
        consent and if so, notify You accordingly.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;When We ask for such Personal Data, You may always decline,
        however, should You decline to
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        provide Us with the necessary data that We require to provide requested
        services, We may not necessarily be able to provide You with such
        services (especially if consent is the only legal ground that is
        available to Us).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;Just to clarify, consent is not the only ground that permits Us to
        process Your Personal Data. In the last preceding section above We
        pointed out the various grounds that We rely on when processing Your
        Personal Data for specific purposes.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>ACCURACY OF PERSONAL DATA</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        All reasonable efforts are made to keep any Personal Data We may hold
        about You up-to-date and as accurate as possible. You can check the
        information that We hold about You at any time by contacting Us in the
        manner explained below. If You find any inaccuracies, We will correct
        them and where required, delete them as necessary. Please see below for
        a detailed list of Your legal rights in terms of any applicable data
        protection law.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>DIRECT MARKETING</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        We only send mail, messages and other communications relating to
        marketing where We are
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        authorised to do so at law. In most cases, We rely on Your consent to do
        so (especially where We use electronic communications). If, at any time,
        You no longer wish to receive direct marketing communications from Us
        please let Us know by contacting Us at the details below or update Your
        preferences on any of Our App(s) or Apps (where applicable).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        In the case of direct marketing sent by electronic communications (where
        We are legally authorised to do so), You will be given an easy way of
        opting out (or unsubscribing) from any such communications.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Please note that even if You withdraw any consent You may have given Us
        or if You object to receiving such direct marketing material from Us (in
        those cases where We do not need Your consent), from time to time We may
        still need to send You certain important communications from which You
        cannot opt-out.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>INTERNET COMMUNICATIONS</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;You will be aware that data sent via the Internet may be
        transmitted across international borders even where sender and receiver
        of information are located in the same country. We cannot be held
        responsible for anything done or omitted to be done by You or any third
        party in connection with any Personal Data prior to Our receiving it
        including but not limited to any transfers of Personal Data from You to
        Us via a country having a lower level of data protection than that in
        place in the European Union, and this, by any technological means
        whatsoever (for example, WhatsApp, Skype, Dropbox etc.).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Moreover, We shall accept no responsibility or liability whatsoever for
        the security of Your data while in transit through the internet unless
        Our responsibility results explicitly from a law having effect in Malta.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>AUTHORISED DISCLOSURES</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        &nbsp;Without prejudice to anything contained in this Privacy Policy and
        in the interest of full transparency, We reserve the right to disclose
        (and otherwise process) any relevant Personal Data relating to You which
        We may be processing (including in certain cases relevant IP addresses)
        to authorised third parties in or outside the EU/EEA if such disclosures
        are allowed under the Data Protection Laws (whether or not You have
        provided Your consent) including but not limited to:
      </p>
      <ol
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'decimal',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            For the purpose of preventing, detecting or suppressing fraud (for
            example, if You provide false or deceptive information about
            Yourself or attempt to pose as someone else, We may disclose any
            information We may have about You in Our possession so as to assist
            any type of investigation into Your actions);
          </p>
        </li>
        <li style={{ marginTop: '4px' }}>
          <p style={{ margin: '0px', padding: '0px;' }}>
            In the event of MINISTRY FOR THE NATIONAL HERITAGE, THE ARTS AND
            LOCAL GOVERNMENT being involved in a merger, sale, restructure,
            acquisition, joint venture, assignment, transfer;
          </p>
        </li>
        <li style={{ marginTop: '4px' }}>
          <p style={{ margin: '0px', padding: '0px;' }}>
            To protect and defend Our rights (including the right to property),
            safety, or those of Our affiliates, of Users of Our App or even Your
            own;
          </p>
        </li>
        <li style={{ marginTop: '4px' }}>
          <p style={{ margin: '0px', padding: '0px;' }}>
            To protect against abuse, misuse or unauthorised use of Our App;
          </p>
        </li>
        <li style={{ marginTop: '4px' }}>
          <p style={{ margin: '0px', padding: '0px;' }}>
            For any purpose that may be necessary for the performance of any
            agreement You may have entered into with Us (including the request
            for provision of services by third parties) or in order to take
            steps at Your request prior to entering into a contract;
          </p>
        </li>
        <li style={{ marginTop: '4px' }}>
          <p style={{ margin: '0px', padding: '0px;' }}>
            To comply with any legal obligations such as may arise by way of
            response to any Court subpoena or order or similar official request
            for Personal Data; or as may otherwise be specifically allowed or
            required by or under any applicable law (for example, under
            anti-money laundering legislation).
          </p>
        </li>
        <li style={{ marginTop: '4px' }}>
          <p style={{ margin: '0px', padding: '0px;' }}>
            To conduct interviews/questionnaires for educational purposes on
            behalf of MINISTRY FOR THE NATIONAL HERITAGE, THE ARTS AND LOCAL
            GOVERNMENT employees.
          </p>
        </li>
      </ol>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>
          SHARING OF PERSONAL DATA WITH OTHER CATEGORIES OF RECIPIENTS
        </strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Relevant data will also be disclosed or shared as appropriate (and in
        all cases in line with the Data Protection Laws) to/with members and
        staff of MINISTRY FOR THE NATIONAL HERITAGE, THE ARTS AND LOCAL
        GOVERNMENT, to/with other entities within the MINISTRY FOR THE NATIONAL
        HERITAGE, THE ARTS AND LOCAL GOVERNMENT Group and/or to/with affiliated
        entities and/or sub-contractors established within the European Union if
        pertinent to any of the purposes listed in this Privacy Policy
        (including to/with Our services providers who facilitate the
        functionality of the App and/or any service You may require). Personal
        information will only be shared by Us to provide the services You
        request from Us or for any other lawful reason (including authorised
        disclosures not requiring Your consent).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Any such authorised disclosures will be done in accordance with the Data
        Protection laws (for example all Our processors are contractually bound
        by the requirements in the said Data Protection Laws, including a strict
        obligation to keep any information they receive confidential and to
        ensure that their employees/personnel are also bound by similar
        obligations). The said service providers (Our processors) are also bound
        by a number of other obligations (in particular, Article 28 of the
        GDPR). &nbsp;Your Personal Data will never be shared with third parties
        for their marketing purposes (unless You give Your consent thereto).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>SECURITY MEASURES</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        The personal information which We may hold (and/or transfer to any
        affiliates/partners/subcontractors as the case may be) will be held
        securely in accordance with Our internal security policy and the law.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        We use reasonable efforts to safeguard the confidentiality of any and/or
        all Personal Data that We may process relating to You and regularly
        review and enhance Our technical, physical and managerial procedures so
        as to ensure that Your Personal Data is protected from:
      </p>
      <ul
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'disc',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>Unauthorised access</p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Improper use or disclosure
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Unauthorised modification
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Unlawful destruction or accidental loss.
          </p>
        </li>
      </ul>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        To this end, We have implemented security policies, rules and technical
        and organisational measures to protect the Personal Data that We may
        have under Our control. All our members, staff and data processors
        (including specific subcontractors, including cloud service providers
        established within the European Union), who may have access to and are
        associated with the processing of Personal Data, are further obliged
        (under contract) to respect the confidentiality of Our Users‟ or
        clients‟ Personal Data as well as other obligations as imposed by the
        Data Protection Laws.
      </p>

      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Despite all the above, We cannot guarantee that a data transmission or a
        storage system can ever be 100% secure. For more information about Our
        security measures please contact Us in the manner described below.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Authorised third parties, and external/third-party service providers,
        with permitted access to Your information (as explained in this Privacy
        Policy), are specifically required to apply appropriate technical and
        organisational security measures that may be necessary to safeguard the
        Personal Data being processed from unauthorised or accidental
        disclosure, loss or destruction and from any unlawful forms of
        processing.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        As stated above, the said service providers (Our data processors) are
        also bound by a number of other obligations in line with the Data
        Protection Laws (particularly, Article 28 of the GDPR). For the
        avoidance of all doubt, these are the same obligations that we are bound
        by when acting as data processor on behalf of one or more data
        controllers.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>RETENTION PERIODS</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        We will retain Your Personal Data only for as long as is necessary
        (taking into consideration the purpose for which it was originally
        obtained). The criteria We use to determine what is &quot;necessary‟
        depends on the particular Personal Data in question and the specific
        relationship We have with You (including its duration).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Our normal practice is to determine whether there is/are any specific EU
        and/or Maltese law(s) (for example tax or corporate laws) permitting or
        even obliging Us to keep certain Personal Data for a certain period of
        time (in which case We will keep the Personal Data for the maximum
        period indicated by any such law). For example, any data that can be
        deemed to be &quot;accounting records‟ must be kept for ten (10 years).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        We would also have to determine whether there are any laws and/or
        contractual provisions that may be invoked against Us by You and/or
        third parties and if so, what the prescriptive periods for such actions
        are (this is usually five (5) years). In the latter case, We will keep
        any relevant Personal Data that We may need to defend Ourselves against
        any claim(s), challenge(s) or other such action(s) by You and/or third
        parties for such time as is necessary.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Where Your Personal Data is no longer required by Us, We will either
        securely delete or anonymise the Personal Data in question.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>PROCESSING FOR RESEARCH AND STATISTICAL REASONS</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Research and statistics using User or client information are only
        carried out so that We may understand Our Users&apos; and/or
        clients&apos; needs, to develop and improve Our services/activities
        and/or for philanthropic goals representative of MINISTRY FOR THE
        NATIONAL HERITAGE, THE ARTS AND LOCAL GOVERNMENT‟s purpose. In any case,
        We will always ensure to obtain any consent We may legally require from
        You beforehand. As in all other cases, We will also ensure to implement
        all appropriate safeguards as may be necessary.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>LINKS TO THIRD PARTY SOURCES</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Links that We provide to third-party web apps are clearly marked and We
        are not in any way whatsoever responsible for (nor can We be deemed to
        endorse in any way) the content of such web apps (including any
        applicable privacy policies or data processing operations of any kind).
        We suggest that You should read the privacy policies of any such
        third-party web apps.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>COOKIES</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        We currently don&rsquo;t collect any cookies from our App. Should this
        change in the future, this privacy policy document will be updated
        immediately.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>MINORS</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        If You are under the age of consent, please consult and get Your
        parent‟s or legal guardian&rsquo;s
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        permission to use the App and to use Our services. &nbsp;
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        We shall consider that any Personal Data of persons under the age of
        eighteen (18) received by Us, shall be sent with the proper authority
        and that the sender can demonstrate such authority at any time, upon Our
        request.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>YOUR RIGHTS UNDER THE DATA PROTECTION LAWS</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Before addressing any request You make with Us, We may first need to
        verify Your identity. In all cases, We will try to act on Your requests
        as soon as reasonably possible.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        As explained in the Retention Periods section above, We may need to keep
        certain Personal Data for compliance with Our legal retention
        obligations but also to complete transactions that You requested prior
        to the change or deletion that You requested.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Please note as a DATA PROCESSOR, Handson Systems Ltd. processes personal
        data on behalf of one or more data controllers - In this case, the DATA
        CONTROLLER is MINISTRY FOR THE NATIONAL HERITAGE, THE ARTS AND LOCAL
        GOVERNMENT. Queries will generally be directed to MINISTRY FOR THE
        NATIONAL HERITAGE, THE ARTS AND LOCAL GOVERNMENT
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        As a data controller, Your various rights at law in so far as We are
        concerned to include:
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Your Right of Access
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        You may, at any time request Us to confirm whether or not We are
        processing Personal Data that concerns You and, if We are, You shall
        have the right to access that Personal Data and to the following
        information:
      </p>
      <ul
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'disc',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            What Personal Data We have,
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>Why We process them,</p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Who We disclose them to,
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            How long We intend on keeping them for (where possible),
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Whether We transfer them abroad and the safeguards We take to
            protect them,
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            What Your rights are,
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            How You can make a complaint,
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Where We got Your Personal Data from and Upon request, We shall
            (without adversely affecting the rights and freedoms of others
            including Our own) provide You with a copy of the Personal Data
            undergoing processing within one month of receipt of the request,
            which period may be extended by two months where necessary, taking
            into account the complexity and number of the requests. We shall
            inform You of any such extension within one month of receipt of the
            request, together with the reasons for the delay.
          </p>
        </li>
      </ul>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Your Right to Rectification
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        You have the right to ask Us to rectify inaccurate Personal Data and to
        complete incomplete Personal Data concerning You. We may seek to verify
        the accuracy of the data before rectifying it.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Your Right to Erasure (The Right to be Forgotten)
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        You have the right to ask Us to delete Your Personal Data and We shall
        comply without undue delay but only where:
      </p>
      <ul
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'disc',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            The Personal Data are no longer necessary for the purposes for which
            they were collected; or
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            You have withdrawn Your consent (in those instances where We process
            on the basis of Your consent) and We have no other legal ground to
            process Your Personal Data; or
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            You shall have successfully exercised Your right to object (as
            explained below); or
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Your Personal Data shall have been processed unlawfully; or
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            There exists a legal obligation to which We are subject; or
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Special circumstances exist in connection with certain
            children&rsquo;s rights.
          </p>
        </li>
      </ul>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        In any case, We shall not be legally bound to comply with Your erasure
        request if the processing of Your Personal Data is necessary:
      </p>
      <ul
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'disc',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            For compliance with a legal obligation to which We are subject
            (including but not limited to Our data retention obligations); or
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            For the establishment, exercise or defence of legal claims.
          </p>
        </li>
      </ul>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        There are other legal grounds entitling Us to refuse erasure requests
        although the two instances above are the most likely grounds that may be
        invoked by Us to deny such requests.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Your Right to Data Restriction
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        You have the right to ask Us to restrict (that is, store but not further
        process) Your Personal Data but only where:
      </p>
      <ul
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'disc',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            The accuracy of Your Personal Data is contested (see the right to
            data rectification above), for a period enabling Us to verify the
            accuracy of the Personal Data; or
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            The processing is unlawful and You oppose the erasure of Your
            Personal Data; or
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            We no longer need the Personal Data for the purposes for which they
            were collected but You need the Personal Data for the establishment,
            exercise or defence of legal claims; or
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            You exercised Your right to object and verification of Our
            legitimate grounds to override Your objection is pending.
          </p>
        </li>
      </ul>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Following Your request for restriction, except for storing Your Personal
        Data, We may only process Your Personal Data:
      </p>
      <ul
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'disc',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            Where We have Your consent; or
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            For the establishment, exercise or defence of legal claims; or
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            For the protection of the rights of another natural or legal person;
            or
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            For reasons of important public interest.
          </p>
        </li>
      </ul>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Your Right to Data Portability
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        You have the right to ask Us to provide Your Personal Data (that You
        shall have provided to Us) to You in a structured, commonly used,
        machine-readable format, or (where technically feasible) to have it
        &apos;ported&apos; directly to another data controller, provided this
        does not adversely affect the rights and freedoms of others.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        This right shall only apply where:
      </p>
      <ul
        style={{
          margin: '12px 0px 0px',
          padding: '0px 0px 0px 40px',
          listStyleType: 'disc',
        }}
      >
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            The processing is based on Your consent or on the performance of a
            contract with You; and
          </p>
        </li>
        <li>
          <p style={{ margin: '0px', padding: '0px;' }}>
            The processing is carried out by automated means.
          </p>
        </li>
      </ul>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Your Right to Withdraw Consent (when We rely on consent)
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        See Our Special Note on Consent for detailed information on this right
        (which You may exercise at any time).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Your Right to Object to Certain Processing
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        In those cases where We only process Your Personal Data when this is 1.)
        necessary for the performance of a task carried out in the public
        interest or 2.) when processing is necessary for the purposes of the
        legitimate interests pursued by Us or by a third party, You shall have
        the right to object to the processing of Your Personal Data by Us. Where
        an objection is entered, the processing of data shall cease, unless We
        as data controllers provide compelling and legitimate grounds requiring
        the continuation of the data processing which outweighs the objections
        You may have raised.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        When Your data is processed for direct marketing purposes, You have the
        right to object at any time to the processing of Your Personal Data,
        which includes profiling to the extent that it is related to such direct
        marketing.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        For the avoidance of all doubt, when We process Your Personal Data when
        this is necessary for the performance of a contract, when necessary for
        compliance with a legal obligation to which We are subject or when
        processing is necessary to protect Your vital interests or those of
        another natural person, this general right to object shall not subsist.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Your Right to Lodge a Complaint
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        You also have the right to lodge complaints with the appropriate Data
        Protection Supervisory Authority. The competent authority in Malta is
        the Office of the Information and Data Protection Commissioner (OIDPC).
        We kindly ask that You please attempt to resolve any issues You may have
        with Us first (even though, as stated above, You have a right to contact
        the competent authority at any time).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        What we may require from you
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        As one of the security measures We implement, before being in the
        position to help You exercise Your rights as described above We may need
        to verify Your identity to ensure that We do not disclose to or share
        any Personal Data with any unauthorised individuals.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Time limit for a response
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        We try to reply to all legitimate requests within one month from
        receiving them. In some particular cases (for example, if the matter is
        particularly complex or if You send Us multiple requests), it may take
        Us longer than a month. In such cases, we will notify You accordingly
        and keep You updated.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>
          DATA CONTROLLER - ​MINISTRY FOR THE NATIONAL HERITAGE, THE ARTS AND
          LOCAL GOVERNMENT - COMPANY DETAILS
        </strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        MINISTRY FOR THE NATIONAL HERITAGE, THE ARTS AND LOCAL GOVERNMENT is the
        Data Controller for the Museum Sense system that is branded under the
        name eXplore Malta.
      </p>

      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Culture Directorate
        <br />
        Chateau de La Ville,
        <br />
        Archbishop Street,
        <br />
        Valletta
        <br />
        <br />
        Telephone:
        <br />
        +356 2558 4970
        <br />
        <br />
        Email:&nbsp;
        <a
          href="mailto:culture@gov.mt​"
          style={{ color: 'rgb(0, 82, 204)', textDecoration: 'none' }}
        >
          culture@gov.mt
        </a>
        <br />
        <br />
        Website:
        <br />
        www.culture.gov.mt
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>DATA PROCESSOR - HANDSON SYSTEMS LTD. - COMPANY DETAILS</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        HandsOn Systems Ltd. a company registered in Malta with company
        registration number C 50462, and whose registered office address is at
        Handson Systems Ltd. 10, Triq L-Industrija, Qormi QRM 3011, Malta is the
        data processor responsible for processing Your Personal Data that takes
        place via the App or in the manner explained above (or in the condensed
        privacy policy or notice that directed You here).
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        If You have any questions/ comments about privacy as a data controller
        or should You wish to exercise any of Your individual rights, please
        contact Us at:&nbsp;
        <a
          href="mailto:privacy@handsonsystems.com"
          style={{ color: 'rgb(0, 82, 204)', textDecoration: 'none' }}
        >
          privacy@handsonsystems.com
        </a>
        , by writing to Handson Systems Ltd. 10, Triq L-Industrija, Qormi QRM
        3011, by phoning us using telephone number (+356) 2722-4445 (during
        normal office hours 9.00 am &ndash; 5.00 pm).&nbsp;
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <h5
        style={{
          margin: '16px 0px 0px',
          padding: '0px',
          fontSize: '0.857em',
          fontStyle: 'inherit',
          lineHeight: '1.333',
          color: 'rgb(23, 43, 77)',
          fontWeight: 'bold',
          letterSpacing: '-0.003em',
        }}
      >
        <strong>UPDATES</strong>
      </h5>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        We reserve the right, at Our complete discretion, to change, modify, add
        and/or remove portions of this Privacy Policy at any time. If You are an
        existing client with whom We have a contractual relationship You shall
        be informed by Us of any changes made to this Privacy Policy (as well as
        other terms and conditions relevant to the App). We shall also archive
        and store previous versions of the Privacy Policy for Your review.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        As a User of the App with which We have no contractual relationship or
        even a lawful way of tracing, it is in Your interest to regularly check
        for any updates to this Privacy Policy (which are usually deemed to be
        effective on the date they are published on the App), in the event that
        Our attempts to notify You of such updates do not reach You.
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>
        Last Updated on 20th July 2021
      </p>
      <p style={{ margin: '12px 0px 0px', padding: '0px;' }}>&nbsp;</p>
    </CustomContent>
  );
};

export default ExploreMaltaPolicy;
